import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabsService {
	organisationId$ = new BehaviorSubject<string>('');

	constructor() { }
}
